import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "native-is-logged-in"

  connect() {
    super.connect()

    this.element.addEventListener('manual-disconnect', this.handleManualDisconnect.bind(this))

    const element = this.bridgeElement
    const title = element.bridgeAttribute("title")

    this.send("logged-in", { title }, () => {
    })
  }

  handleManualDisconnect() {
    this.send("logged-out", {})
  }

  disconnect() {
    super.disconnect()
    this.send("logged-out", {})
    if (this.element.parentNode) {
      this.element.parentNode.removeChild(this.element)
    }
  }
}
